class ProductPopup extends HTMLElement {
  carouselGlide;
  constructor() {
    super();
  }

  init() {
    this.setFlavorSelectorEvent();
    this.initGallery();
  }

  connectedCallback() {
    this.init();
  }

  initGallery() {
    this.carouselGlide = new Glide(
      "#" + this.id + " .js--section-product__slider",
      {
        type: "carousel",
        startAt: 0,
        perView: 1,
      }
    ).mount();
  }

  updateGallery() {
    this.querySelectorAll(".gallery img").forEach((img) => {
      img.loading = "eager";
    });
    this.carouselGlide.update();
  }

  setFlavorSelectorEvent() {
    this.querySelectorAll(
      "product-popup .additional-flavors-dropdown-container .select__label a"
    )?.forEach((linkEl) => {
      linkEl.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const handle = linkEl.dataset.handle;
        if (!handle) {
          return false;
        }

        fetch(
          window.Shopify.routes.root +
            "products/" +
            handle +
            "?section_id=product-popup-section"
        )
          .then((response) => response.text())
          .then((html) => {
            console.log("html", html);
            this.closest("product-popup").replaceWith(
              new DOMParser()
                .parseFromString(html, "text/html")
                .querySelector("product-popup")
            );
            window.priceSelectorV2?.init();
            window.priceSelectorV2?.onIgReady();
            window.priceSelectorV2?.triggerAllSSCardSelects();
          });

        return false;
      });
    });
  }
} // end ProductPopup

if (!customElements.get("product-popup")) {
  customElements.define("product-popup", ProductPopup);
}
